import StructureEditorType from '@Containers/StructureEditor/constants';
import isEmpty from 'lodash/isEmpty';
import Catalyst from '@Services/Catalyst';
import { getProjectRoutesTypeForAA } from '@Pages/RetroSynthesis/constants';

export const onPageLoad = (project) => {
  const doesProjectExist = !isEmpty(project);
  Catalyst.trackEvent('newPage', {
    page: {
      name: 'retrosynthesis:draw',
    },
    content: [
      {
        id: doesProjectExist ? `project:${project.id}` : '',
        format: 'project',
        type: doesProjectExist ? getProjectRoutesTypeForAA(project) : 'project',
        details: doesProjectExist ? 'edited' : 'created',
      },
    ],
  });
};

const editorTypeToButtonNameMap = {
  [StructureEditorType.MARVIN]: 'marvin-js',
  [StructureEditorType.CHEMDRAW]: 'chemdraw',
};
export const onEditorTypeSelected = (editorType) => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: `retrosynthesis:draw:${editorTypeToButtonNameMap[editorType]}`,
  });
};

export const onDrawingCleared = () => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'retrosynthesis:draw:clear',
  });
};

export const onDrawingCancelled = () => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'retrosynthesis:draw:cancel',
  });
};
